var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * @fileoverview added by tsickle
 * Generated from: models/visit.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { isEqual } from 'lodash-es';
import { nowNaive } from '../util/datetime/index';
import { defineModelProperties } from '../util/model';
import { jobModelMixin } from './job.mixin';
import { PrimaryTaskType, TaskType } from './task';
/** @enum {string} */
var VisitSkippedBy = {
    /** The visit was skipped by the customer. */
    Customers: "customers",
    /** The visit was skipped by Housekeep staff. */
    Staff: "staff",
    /** The visit was skipped by the worker. */
    Workers: "workers",
};
export { VisitSkippedBy };
/** @enum {string} */
var VisitWorkerPropertyAccess = {
    /** The worker can access the property for this visit, because they have the key or no key is required. */
    CanAccess: "can_access",
    /** The worker cannot access the property for this visit, because the key is lost, destroyed or does not exist. */
    CannotAccess: "cannot_access",
    /** The worker cannot access the property unless the customer transfers a key to the worker before the visit. */
    CustomerToWorkerTransferRequired: "cwtransfer",
    /** The worker cannot access the property unless the worker picks up a key from the Housekeep office the visit. */
    TransferRequired: "transfer",
    /** The worker cannot access the property unless a key is transferred from another worker before the visit. */
    WorkerToWorkerTransferRequired: "wwtransfer",
};
/** @enum {string} */
var VisitSkippedReason = {
    Access: "access",
    AtHome: "athome",
    CancelFlow: "cancelflow",
    Covid: "covid",
    Forgot: "forgot",
    Holiday: "holiday",
    Illness: "illness",
    IncorrectAddress: "address",
    NeedLessOften: "needlessoften",
    NoAnswerAtDoor: "noanswer",
    PreferredHousekeeperNotAvailable: "preferredhknotavail",
    Unhappy: "unhappy",
    Withheld: "withheld",
};
export { VisitSkippedReason };
/**
 * A map of `SkipReason` to readable description of the skip reason, used for display and user-selection purposes.
 * This does not include the COVID-19 reasons, as we display these to the user in a separate form control.
 * @type {?}
 */
var LATE_SKIP_REASON_ARRAY = [
    [VisitSkippedReason.Holiday, 'Holiday'],
    [VisitSkippedReason.Covid, 'COVID-19'],
    [VisitSkippedReason.PreferredHousekeeperNotAvailable, 'Preferred Housekeeper not available'],
    [VisitSkippedReason.AtHome, "I'll be at home"],
    [VisitSkippedReason.Forgot, 'Forgot to skip in advance'],
    [VisitSkippedReason.Access, "Can't provide access"],
    [VisitSkippedReason.Illness, 'Illness'],
    [VisitSkippedReason.NeedLessOften, 'Need a clean less often'],
    [VisitSkippedReason.Unhappy, 'Unhappy with service'],
    [VisitSkippedReason.IncorrectAddress, 'Incorrect address'],
    [VisitSkippedReason.NoAnswerAtDoor, 'No answer at door'],
    [VisitSkippedReason.Withheld, 'Something else']
];
/** @type {?} */
export var LATE_SKIP_REASON_CHOICES = new Map(__spread(LATE_SKIP_REASON_ARRAY));
var ɵ0 = /**
 * @param {?} __0
 * @return {?}
 */
function (_a) {
    var _b = __read(_a, 1), reason = _b[0];
    return ![
        VisitSkippedReason.IncorrectAddress,
        VisitSkippedReason.NoAnswerAtDoor,
        VisitSkippedReason.Covid,
        VisitSkippedReason.PreferredHousekeeperNotAvailable,
        VisitSkippedReason.AtHome,
        VisitSkippedReason.Forgot,
        VisitSkippedReason.Illness
    ].includes(reason);
};
/**
 * Skip reasons for future visits should not include the following reasons. We need to maintain the full skip reasons
 * array to ensure that skip reason display continues to function.
 * @type {?}
 */
var SKIP_REASON_ARRAY = LATE_SKIP_REASON_ARRAY.filter((ɵ0));
/** @type {?} */
export var SKIP_REASON_CHOICES = new Map(__spread(SKIP_REASON_ARRAY));
var ɵ1 = /**
 * @param {?} __0
 * @return {?}
 */
function (_a) {
    var _b = __read(_a, 1), reason = _b[0];
    return [VisitSkippedReason.Unhappy, VisitSkippedReason.Illness, VisitSkippedReason.Covid].indexOf(reason) === -1;
};
/**
 * Skip reasons for displaying content that do not include `Illness` or
 * `Unhappy` reasons.
 * @type {?}
 */
var OTHER_SKIP_REASONS_ARRAY = SKIP_REASON_ARRAY.filter((ɵ1));
/** @type {?} */
export var OTHER_SKIP_REASON_CHOICES = new Map(__spread(OTHER_SKIP_REASONS_ARRAY));
/** @type {?} */
export var TASKS_ORDER = [
    TaskType.Cleaning,
    TaskType.Fridge,
    TaskType.IndoorWindows,
    TaskType.Ironing,
    TaskType.Laundry,
    TaskType.Oven,
    TaskType.Products
];
/** @enum {string} */
var FinishedEarlyReasons = {
    ForgetToPressStart: "forgot-to-set-start",
    RemainingTimeNotRequired: "remaining-time-not-required",
};
export { FinishedEarlyReasons };
/** @enum {string} */
var VisitState = {
    Scheduled: "scheduled",
    Started: "started",
    Finished: "finished",
    InProgress: "in_progress",
};
export { VisitState };
/**
 * Base model for a visit, containing all relevant fields returned by the API.
 * @record
 */
function BaseVisitModel() { }
if (false) {
    /** @type {?} */
    BaseVisitModel.prototype.id;
    /** @type {?} */
    BaseVisitModel.prototype.access;
    /** @type {?} */
    BaseVisitModel.prototype.accountId;
    /** @type {?} */
    BaseVisitModel.prototype.actualDate;
    /** @type {?} */
    BaseVisitModel.prototype.anyWorker;
    /** @type {?} */
    BaseVisitModel.prototype.customerBilledForSkipAfter;
    /** @type {?} */
    BaseVisitModel.prototype.customerCanAlter;
    /** @type {?} */
    BaseVisitModel.prototype.customerCanSkip;
    /** @type {?} */
    BaseVisitModel.prototype.details;
    /** @type {?} */
    BaseVisitModel.prototype.electiveSkipAndPay;
    /** @type {?} */
    BaseVisitModel.prototype.failedBillingBlockUnskip;
    /** @type {?} */
    BaseVisitModel.prototype.finished;
    /** @type {?} */
    BaseVisitModel.prototype.finishedAt;
    /** @type {?} */
    BaseVisitModel.prototype.finishedEarlyReason;
    /** @type {?} */
    BaseVisitModel.prototype.isFirstVisit;
    /** @type {?} */
    BaseVisitModel.prototype.isHomeClean;
    /** @type {?} */
    BaseVisitModel.prototype.isReviewable;
    /** @type {?} */
    BaseVisitModel.prototype.isSpecialistClean;
    /** @type {?} */
    BaseVisitModel.prototype.isTradespeople;
    /** @type {?} */
    BaseVisitModel.prototype.jobId;
    /** @type {?} */
    BaseVisitModel.prototype.propertyId;
    /** @type {?} */
    BaseVisitModel.prototype.scheduledDate;
    /** @type {?} */
    BaseVisitModel.prototype.skipped;
    /** @type {?|undefined} */
    BaseVisitModel.prototype.skippedByUserRole;
    /** @type {?} */
    BaseVisitModel.prototype.startedAt;
    /** @type {?} */
    BaseVisitModel.prototype.timeSlot;
    /** @type {?} */
    BaseVisitModel.prototype.tasks;
    /** @type {?} */
    BaseVisitModel.prototype.tipAmountPounds;
    /** @type {?} */
    BaseVisitModel.prototype.weekBeginning;
    /** @type {?} */
    BaseVisitModel.prototype.workerPropertyAccess;
    /** @type {?} */
    BaseVisitModel.prototype.isDeepClean;
    /** @type {?} */
    BaseVisitModel.prototype.isHomeAnchorRemoteKeyTransfer;
    /** @type {?} */
    BaseVisitModel.prototype.remoteKeyTransferType;
}
/**
 * @record
 */
export function ChangesToVisitFromJob() { }
if (false) {
    /** @type {?} */
    ChangesToVisitFromJob.prototype.accessChanged;
    /** @type {?} */
    ChangesToVisitFromJob.prototype.arrivalTimeChanged;
    /** @type {?} */
    ChangesToVisitFromJob.prototype.dateChanged;
    /** @type {?} */
    ChangesToVisitFromJob.prototype.durationChanged;
    /** @type {?} */
    ChangesToVisitFromJob.prototype.tasksChanged;
    /** @type {?} */
    ChangesToVisitFromJob.prototype.workerChanged;
}
/**
 * Optional expandable fields that can be requested from the API.
 * @record
 */
function VisitExpandables() { }
if (false) {
    /** @type {?|undefined} */
    VisitExpandables.prototype.changesToVisitFromJob;
    /** @type {?} */
    VisitExpandables.prototype.estimatedStart;
    /** @type {?|undefined} */
    VisitExpandables.prototype.account;
    /** @type {?|undefined} */
    VisitExpandables.prototype.job;
    /** @type {?|undefined} */
    VisitExpandables.prototype.property;
    /** @type {?|undefined} */
    VisitExpandables.prototype.workers;
    /** @type {?|undefined} */
    VisitExpandables.prototype.workerHasVisitedBefore;
    /** @type {?|undefined} */
    VisitExpandables.prototype.recommendedStartTimeSlot;
    /** @type {?|undefined} */
    VisitExpandables.prototype.workerCanCallCustomer;
    /** @type {?|undefined} */
    VisitExpandables.prototype.remoteKeyTransferKeys;
    /** @type {?|undefined} */
    VisitExpandables.prototype.isWithinExtraJobsSignal;
    /** @type {?|undefined} */
    VisitExpandables.prototype.isWithinRegularWorkingArea;
    /** @type {?|undefined} */
    VisitExpandables.prototype.isWithinRegularWorkingHours;
    /** @type {?|undefined} */
    VisitExpandables.prototype.customerPreferredName;
    /** @type {?|undefined} */
    VisitExpandables.prototype.requiredKeys;
    /** @type {?|undefined} */
    VisitExpandables.prototype.ratings;
    /** @type {?|undefined} */
    VisitExpandables.prototype.remoteKeyTransfers;
}
/**
 * @record
 */
function VisitModelMixin() { }
if (false) {
    /** @type {?} */
    VisitModelMixin.prototype.tasksDifferFromJob;
    /** @type {?} */
    VisitModelMixin.prototype.finish;
    /** @type {?} */
    VisitModelMixin.prototype.start;
    /** @type {?} */
    VisitModelMixin.prototype.unstart;
    /** @type {?|undefined} */
    VisitModelMixin.prototype.estimatedStartDisplay;
    /** @type {?|undefined} */
    VisitModelMixin.prototype.expectedFinish;
    /** @type {?} */
    VisitModelMixin.prototype.isEditNoticeSufficient;
    /** @type {?} */
    VisitModelMixin.prototype.isCustomerAllowedToEdit;
    /** @type {?} */
    VisitModelMixin.prototype.isKeyReturnOnly;
    /** @type {?} */
    VisitModelMixin.prototype.isInProgress;
    /** @type {?} */
    VisitModelMixin.prototype.isRescheduled;
    /** @type {?} */
    VisitModelMixin.prototype.isRescheduledDate;
    /** @type {?} */
    VisitModelMixin.prototype.isRescheduledTime;
    /** @type {?} */
    VisitModelMixin.prototype.isSkipBilled;
    /** @type {?} */
    VisitModelMixin.prototype.isSkippedByCustomer;
    /** @type {?} */
    VisitModelMixin.prototype.isSkippedByStaff;
    /** @type {?} */
    VisitModelMixin.prototype.isSkippedByUnknown;
    /** @type {?} */
    VisitModelMixin.prototype.isSkippedByWorker;
    /** @type {?} */
    VisitModelMixin.prototype.isSkippedLateByCustomer;
    /** @type {?} */
    VisitModelMixin.prototype.isTradesSurvey;
    /** @type {?} */
    VisitModelMixin.prototype.labelledTasks;
    /** @type {?|undefined} */
    VisitModelMixin.prototype.primaryTask;
    /** @type {?|undefined} */
    VisitModelMixin.prototype.remoteKeyTransferKeysToCollect;
    /** @type {?|undefined} */
    VisitModelMixin.prototype.remoteKeyTransferWorkers;
    /** @type {?} */
    VisitModelMixin.prototype.isFinished;
    /** @type {?} */
    VisitModelMixin.prototype.isStarted;
    /** @type {?} */
    VisitModelMixin.prototype.isScheduled;
    /** @type {?} */
    VisitModelMixin.prototype.state;
    /** @type {?} */
    VisitModelMixin.prototype.isKeysVisit;
    /** @type {?} */
    VisitModelMixin.prototype.shouldReturnKeys;
    /** @type {?} */
    VisitModelMixin.prototype.shouldCollectKeys;
    /** @type {?} */
    VisitModelMixin.prototype.isKeysOnlyVisit;
    /** @type {?} */
    VisitModelMixin.prototype.isRemoteKeyTransfer;
    /** @type {?} */
    VisitModelMixin.prototype.isRktHolder;
    /** @type {?} */
    VisitModelMixin.prototype.isRktTraveller;
    /** @type {?} */
    VisitModelMixin.prototype.isRktOnly;
    /** @type {?} */
    VisitModelMixin.prototype.started;
}
/**
 * Model representing a visit.
 * @record
 */
export function Visit() { }
/** @type {?} */
export var visit = jobModelMixin.extend((/** @type {?} */ ({
    modelName: 'visit',
    tasksDifferFromJob: /**
     * @return {?}
     */
    function () {
        return this.getOrCache('tasksDifferFromJob', (/**
         * @return {?}
         */
        function () {
            return !isEqual(this.tasks, this.job.tasks);
        }));
    },
    start: /**
     * @param {?} dateTime
     * @return {?}
     */
    function (dateTime) {
        this.started = true;
        this.startedAt = dateTime;
    },
    unstart: /**
     * @return {?}
     */
    function () {
        this.started = false;
        this.startedAt = null;
    },
    finish: /**
     * @param {?} dateTime
     * @return {?}
     */
    function (dateTime) {
        this.finished = true;
        this.finishedAt = dateTime;
    }
})));
// Implements helper properties declared in `VisitModelMixin`
defineModelProperties(visit, {
    estimatedStartDisplay: {
        get: /**
         * @return {?}
         */
        function () {
            if (this.estimatedStart) {
                return this.estimatedStart.isInstant
                    ? "at " + this.estimatedStart.start.format('HH:mm')
                    : "between " + this.estimatedStart.start.format('HH:mm') + " and " + this.estimatedStart.end.format('HH:mm');
            }
        }
    },
    expectedFinish: {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.startedAt) {
                return this.startedAt.clone().add(this.requiredDuration.toHours(), 'hours');
            }
        }
    },
    isEditNoticeSufficient: {
        get: /**
         * @return {?}
         */
        function () {
            return this.customerCanAlter;
        }
    },
    isCustomerAllowedToEdit: {
        get: /**
         * @return {?}
         */
        function () {
            return this.isEditNoticeSufficient && !this.failedBillingBlockUnskip;
        }
    },
    isKeyReturnOnly: {
        get: /**
         * @return {?}
         */
        function () {
            return !!(this.tasks.length === 1 && this.tasks[0].type === TaskType.KeyReturn);
        }
    },
    isInProgress: {
        get: /**
         * @return {?}
         */
        function () {
            return this.isStarted && !this.isFinished;
        }
    },
    isRescheduled: {
        get: /**
         * @return {?}
         */
        function () {
            return this.isRescheduledDate || this.isRescheduledTime;
        }
    },
    isRescheduledDate: {
        get: /**
         * @return {?}
         */
        function () {
            return !this.actualDate.isSame(this.scheduledDate);
        }
    },
    isRescheduledTime: {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.job) {
                throw new Error('Programming error: `job` is not expanded');
            }
            // If visit slot is the same as job slot, we know for sure that the time is NOT rescheduled
            if (this.timeSlot.equals(this.job.timeSlot)) {
                return false;
            }
            // The visit slot is different to the job slot. If this visit isn't any-time, we know for sure it IS rescheduled
            if (!this.timeSlot.isAnyTime) {
                return true;
            }
            // This visit is any-time, so check if the job will switch to any-time before the visit date
            /** @type {?} */
            var switchDate = this.job.timeSlotAnyTimeSwitchDate;
            return !switchDate || this.scheduledDate.isSameOrBefore(switchDate);
        }
    },
    isSkipBilled: {
        get: /**
         * @return {?}
         */
        function () {
            return nowNaive().isAfter(this.customerBilledForSkipAfter);
        }
    },
    isSkippedByCustomer: {
        get: /**
         * @return {?}
         */
        function () {
            return this.skippedByUserRole === VisitSkippedBy.Customers;
        }
    },
    isSkippedByStaff: {
        get: /**
         * @return {?}
         */
        function () {
            return this.skippedByUserRole === VisitSkippedBy.Staff;
        }
    },
    isSkippedByUnknown: {
        get: /**
         * @return {?}
         */
        function () {
            return this.skipped && !this.skippedByUserRole;
        }
    },
    isSkippedByWorker: {
        get: /**
         * @return {?}
         */
        function () {
            return this.skippedByUserRole === VisitSkippedBy.Workers;
        }
    },
    isSkippedLateByCustomer: {
        get: /**
         * @return {?}
         */
        function () {
            return this.isSkippedByCustomer && this.tasks.some((/**
             * @param {?} task
             * @return {?}
             */
            function (task) { return task.type === TaskType.LateSkip; }));
        }
    },
    isTradesSurvey: {
        get: /**
         * @return {?}
         */
        function () {
            return this.tasks.some((/**
             * @param {?} task
             * @return {?}
             */
            function (task) { return task.type === TaskType.TradesSurvey; }));
        }
    },
    labelledTasks: {
        get: /**
         * @return {?}
         */
        function () {
            return this.tasks ? this.tasks.filter((/**
             * @param {?} task
             * @return {?}
             */
            function (task) { return task.typeLabel; })) : [];
        }
    },
    primaryTask: {
        get: /**
         * @return {?}
         */
        function () {
            var _a;
            if (this.isHomeClean) {
                return PrimaryTaskType.Cleaning;
            }
            if (this.isSpecialistClean) {
                /** @type {?} */
                var primaryTaskTypes_1 = Object.values(PrimaryTaskType);
                return (_a = this.tasks.find((/**
                 * @param {?} task
                 * @return {?}
                 */
                function (task) { return primaryTaskTypes_1.includes(task.type); }))) === null || _a === void 0 ? void 0 : _a.type;
            }
        }
    },
    state: {
        get: /**
         * @return {?}
         */
        function () {
            return this.finishedAt ? VisitState.Finished : this.startedAt ? VisitState.Started : VisitState.Scheduled;
        }
    },
    isScheduled: {
        get: /**
         * @return {?}
         */
        function () {
            return this.state === VisitState.Scheduled;
        }
    },
    isStarted: {
        get: /**
         * @return {?}
         */
        function () {
            return this.state === VisitState.Started;
        }
    },
    isFinished: {
        get: /**
         * @return {?}
         */
        function () {
            return this.state === VisitState.Finished;
        }
    },
    isKeysVisit: {
        get: /**
         * @return {?}
         */
        function () {
            return this.shouldReturnKeys || this.shouldCollectKeys;
        }
    },
    isKeysOnlyVisit: {
        get: /**
         * @return {?}
         */
        function () {
            return this.isKeysVisit && this.tasks.length === 1;
        }
    },
    shouldReturnKeys: {
        get: /**
         * @return {?}
         */
        function () {
            return this.hasTask(TaskType.KeyReturn);
        }
    },
    shouldCollectKeys: {
        get: /**
         * @return {?}
         */
        function () {
            return this.hasTask(TaskType.KeyCollection);
        }
    },
    isRemoteKeyTransfer: {
        get: /**
         * @return {?}
         */
        function () {
            return !!this.remoteKeyTransferType;
        }
    },
    isRktHolder: {
        get: /**
         * @return {?}
         */
        function () {
            return this.isRemoteKeyTransfer && this.remoteKeyTransferType.includes('holder');
        }
    },
    isRktTraveller: {
        get: /**
         * @return {?}
         */
        function () {
            return this.isRemoteKeyTransfer && this.remoteKeyTransferType.includes('traveller');
        }
    },
    isRktOnly: {
        get: /**
         * @return {?}
         */
        function () {
            return this.isRktTraveller || this.isHomeAnchorRemoteKeyTransfer;
        }
    },
    /**
     * Other workers who will meet the user to give or return keys.
     */
    remoteKeyTransferWorkers: {
        get: /**
         * @return {?}
         */
        function () {
            return this.remoteKeyTransfers.map((/**
             * @param {?} transfer
             * @return {?}
             */
            function (transfer) {
                /** @type {?} */
                var remoteKeyTransferWorker = transfer.otherWorker;
                remoteKeyTransferWorker.keysToGive = transfer.keysToTransfer.filter((/**
                 * @param {?} key
                 * @return {?}
                 */
                function (key) { return key.holderId !== remoteKeyTransferWorker.id; }));
                remoteKeyTransferWorker.keysToCollect = transfer.keysToTransfer.filter((/**
                 * @param {?} key
                 * @return {?}
                 */
                function (key) { return key.holderId === remoteKeyTransferWorker.id; }));
                return remoteKeyTransferWorker;
            }));
        }
    },
    /**
     * Keys held by other workers which have not been picked up yet.
     */
    remoteKeyTransferKeysToCollect: {
        get: /**
         * @return {?}
         */
        function () {
            return this.remoteKeyTransferWorkers
                .map((/**
             * @param {?} remoteKeyTransferWorker
             * @return {?}
             */
            function (remoteKeyTransferWorker) {
                return remoteKeyTransferWorker.keysToCollect;
            }))
                .flat();
        }
    }
});
export { ɵ0, ɵ1 };
